import React from "react";
import styled from "styled-components";

const Header = () => {
  return (
    <Container>
      <Title>디지몬상 테스트</Title>
      <SubTitle>나와 닮은 디지몬은?</SubTitle>
    </Container>
  );
};

export default Header;

const Container = styled.div`
  margin-bottom: 10px;
  text-align: center;
`;

const Title = styled.div`
  text-shadow: -3px 0 #3a4ca8, 0 3px #3a4ca8, 3px 0 #3a4ca8, 0 -3px #3a4ca8;
  color: #ffcd4a;

  font-size: 40px;
  padding: 10px 0;
`;

const SubTitle = styled.div`
  text-shadow: -2px 0 #000000, 0 2px #000000, 2px 0 #000000, 0 -2px #000000;
  color: white;
  font-size: 20px;

  padding: 5px;
`;
